import React from "react";
import { connect } from "react-redux";
import moment from "moment";

import Content from "../../../components/Export/Content";
import Column from "../../../components/Export/Column";
import Table from "../../../components/Export/Table";
import Table2 from "../../../components/Export/Table2";
import Row from "../../../components/Export/Row";

import "./ClockInOutSummary.css";
import Spinner from "../../../components/UI/Spinner/Spinner";
import Filter from "../../../helpers/Filter";
import Axios from "axios";
import NoData from "../../../components/UI/Spinner/NoData";
import Configs from "../../../Configs";

const styleRow = {};

const styleRowTotal = {
  borderBottom: "2px solid #f4f4f4",
  borderTop: "2px solid #f4f4f4",
};

const keyTotalUnit = "TOTAL_UNIT";
const keyTotalDisplay = "TOTAL_DISPLAY_VALUE";

const titleCol = {
  DEVICE: "Device",
  DEVICE_NAME: "Device Name",
  ACTION: "Action",
  TIME: "Time",
  USER: "User",
  TOTAL_ACTION: "Total",
  PERIOD: "Period",
  VALID: "Valid",
  OUT: "OUT",
  IN: "IN",
  GROUP: "GROUP",
};
const datetimeCol = {
  TIME_DOW: "Time(Day of Week)",
  TIME_D: "Time(Days)",
  TIME_M: "Time(Month)",
  TIME_Y: "Time(Year)",
  TIME_W: "Time(Week)",
  TIME_HOD: "Time(Hour of Day)",
  TIME_HHmm: "Time(HH:mm)",
  TIME_DD_MM_YYYY: "Time(DD-MM-YYYY)",
  TIME_BO_15_M: "Time (Block of 15 minutes)",
  TIME_YYYY_MM_DD: "Time(YYYY-MM-DD)",
  TIME_MILISECONDS: "Time (Miliseconds)",
};

class ClockInOutImportSummary extends React.PureComponent {
  state = {
    reports: [],
    analysis: {},
    loading: false,
    noFile: false,
  };

  componentDidMount() {
    this.setState({
      loading: true,
    });
    Axios.get(`${this.props.file}`)
      .then((res) => {
        this.setState({
          analysis: res.data,
          loading: false,
          noFile: false,
        });
      })
      .catch((res) => {
        this.setState({
          loading: false,
          noFile: true,
        });
      });
  }

  exportPdf = () => {
    let view = document.getElementById("exportReceptBill").innerHTML;
    let popupWinindow = window.open(
      "",
      "_blank",
      "width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no"
    );
    popupWinindow.document.open();
    popupWinindow.document.write(
      '<html><head><link rel="stylesheet" type="text/css" href="' +
        Configs.abossUrl +
        '/assets/css/bootstrap.min.css" /></head><body onload="window.print()">' +
        view +
        "</html>"
    );
    popupWinindow.document.close();
  };

  calculateRoundValue = (value, numOfDecimalPlace, showLessValue) => {
    var partOne = 0;
    var demValue = "1";
    for (var d = 0; d < numOfDecimalPlace; d++) {
      demValue = demValue.toString() + "0".toString();
    }
    demValue = Number(demValue);
    if (value != 0 && value != undefined) {
      partOne = Math.round(value * demValue) / demValue;
    }
    if (showLessValue) {
      partOne = partOne * -1;
    }
    return partOne;
  };

  calculateRoundNumberValue = (value, numOfDecimalPlace, showLessValue) => {
    var partOne = 0;
    var demValue = "1";
    for (var d = 0; d < numOfDecimalPlace; d++) {
      demValue = demValue.toString() + "0".toString();
    }
    demValue = Number(demValue);
    if (value != 0 && value != undefined) {
      partOne = Math.round(value * demValue) / demValue;
    }
    if (showLessValue) {
      partOne = partOne * -1;
    }
    return Filter.displayNumber(partOne);
  };

  setInOutUsers = (results, user, tableTitle, period) => {
    let values = [];
    const userResults =
      results[user + "_" + period] !== undefined
        ? results[user + "_" + period]
        : [];
    const userResultsLength = userResults.length;
    for (var m = 0; m < userResultsLength; m++) {
      const userResult = userResults[m];
      if (userResult === undefined) {
        continue;
      }
      const timeIn =
        userResult[titleCol.IN] !== undefined && userResult[titleCol.IN]
          ? moment(userResult[titleCol.IN]).format("HH:mm:ss")
          : "--:--:--";
      const timeOut =
        userResult[titleCol.OUT] !== undefined && userResult[titleCol.OUT]
          ? moment(userResult[titleCol.OUT]).format("HH:mm:ss")
          : "--:--:--";

      let total = "--:--:--";
      if (userResult[titleCol.VALID] === 1) {
        total =
          userResult[titleCol.TOTAL_ACTION] > 0
            ? moment
                .utc(userResult[titleCol.TOTAL_ACTION] * 1000)
                .format("HH:mm:ss")
            : "00:00:00";
      }

      values.push({
        name: moment(userResult[datetimeCol.TIME_YYYY_MM_DD]).format("LL"),
        val: [timeIn, timeOut, total],
      });
    }

    if (values.length <= 0) {
      return (
        <Table2 title={tableTitle}>
          <tr>
            <td colSpan="4">
              <b>No Data Available</b>
            </td>
          </tr>
        </Table2>
      );
    }

    return (
      <Table2 title={tableTitle} col={4}>
        <Row
          styleRow={styleRowTotal}
          name={"Date"}
          values={["Time In", "Time Out", "Time Taken"]}
        ></Row>
        {values.map((value, key) => {
          return (
            <Row
              key={key}
              styleRow={styleRow}
              name={value.name}
              values={value.val}
            ></Row>
          );
        })}
      </Table2>
    );
  };

  render() {
    let content = <Spinner></Spinner>;

    if (this.state.noFile) {
      return <NoData></NoData>;
    }

    if (!this.state.loading && Object.keys(this.state.analysis).length > 0) {
      const analysis = { ...this.state.analysis };

      const periods = [...analysis.periods];
      let controllerNames = { ...analysis.controllerNames };
      const controllers = [...analysis.controllerIds];
      const controllersName = [];
      const controllersLength = controllers.length;
      for (let i = 0; i < controllersLength; i++) {
        if (controllerNames[controllers[i]] !== undefined) {
          controllersName.push(controllerNames[controllers[i]]);
        }
      }

      const users = [...analysis.users];
      const summaries = { ...analysis.summaries };

      content = periods.map((period, key) => {
        const start = period.range.start;
        const end = period.range.end;

        const description = `FROM ${moment(+start).format("LLL")} TO ${moment(
          +end
        )
          .subtract(1, "minutes")
          .format("LLL")}`;

        const contentDetail = users.map((user, key) => {
          return (
            <table
              key={key}
              style={{
                width: "100%",
              }}
            >
              <tbody>
                <tr>
                  <Column
                    style={{
                      margin: "10px 0px 0px 0px",
                      background: "white",
                      verticalAlign: "top",
                      width: "100%",
                    }}
                  >
                    {this.setInOutUsers(summaries, user, user, period.name)}
                  </Column>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
                <tr
                  style={{
                    borderTop: "2px solid black",
                  }}
                >
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
              </tbody>
            </table>
          );
        });

        return (content = (
          <Content
            key={key}
            title="CLOCK IN/OUT SUMMARY"
            description={description}
            controllers={controllersName.join(", ")}
          >
            {contentDetail}
          </Content>
        ));
      });
    }

    return (
      <div className="ReceptBillSummary">
        <div className="row">
          <div className="col-md-12 col-xs-12 col-lg-12">
            <button className="btn btn-primary" onClick={this.exportPdf}>
              <i className="fa fa-print"></i>
              Print
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 col-xs-12 col-lg-12">
            <div id="exportReceptBill">{content}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default ClockInOutImportSummary;
